import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _activateLoyaltyProgramRequest = {};
var _activateLoyaltyProgramResponse = { loyaltyProgram: '_loyaltyProgram' };
var _bulkGetLoyaltyProgramRequest = {};
var _bulkGetLoyaltyProgramResponse = { programInSites: '_programInSite' };
var _disablePointsExpirationRequest = {};
var _disablePointsExpirationResponse = { loyaltyProgram: '_loyaltyProgram' };
var _enablePointsExpirationRequest = {};
var _enablePointsExpirationResponse = { loyaltyProgram: '_loyaltyProgram' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getLoyaltyProgramDescriptionRequest = {};
var _getLoyaltyProgramDescriptionResponse = {
    updatedDate: 'google.protobuf.Timestamp',
};
var _getLoyaltyProgramPremiumFeaturesRequest = {};
var _getLoyaltyProgramPremiumFeaturesResponse = {};
var _getLoyaltyProgramRequest = {};
var _getLoyaltyProgramResponse = { loyaltyProgram: '_loyaltyProgram' };
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _loyaltyProgram = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    pointDefinition: '_pointDefinition',
};
var _pauseLoyaltyProgramRequest = {};
var _pauseLoyaltyProgramResponse = { loyaltyProgram: '_loyaltyProgram' };
var _pointDefinition = { icon: '_image' };
var _programInSite = { loyaltyProgram: '_loyaltyProgram' };
var _updateLoyaltyProgramDescriptionRequest = {};
var _updateLoyaltyProgramDescriptionResponse = {};
var _updateLoyaltyProgramRequest = { loyaltyProgram: '_loyaltyProgram' };
var _updateLoyaltyProgramResponse = { loyaltyProgram: '_loyaltyProgram' };
function resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-programs',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/loyalty-programs',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/loyalty-programs',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves the loyalty program. */
export function getLoyaltyProgram(payload) {
    var _a = serializer(_getLoyaltyProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoyaltyProgramResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _loyaltyProgram: _loyaltyProgram,
        _pointDefinition: _pointDefinition,
    }).fromJSON;
    function __getLoyaltyProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.GetLoyaltyProgram',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoyaltyProgram.fromReq = fromReq;
    __getLoyaltyProgram.__isAmbassador = true;
    return __getLoyaltyProgram;
}
/**
 * Retrieves loyalty programs for all metasites that the caller is a member of.
 *
 * Must be called with user identity.
 */
export function bulkGetLoyaltyProgram(payload) {
    var _a = serializer(_bulkGetLoyaltyProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetLoyaltyProgramResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _loyaltyProgram: _loyaltyProgram,
        _pointDefinition: _pointDefinition,
        _programInSite: _programInSite,
    }).fromJSON;
    function __bulkGetLoyaltyProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.BulkGetLoyaltyProgram',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/bulk/programs',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetLoyaltyProgram.fromReq = fromReq;
    __bulkGetLoyaltyProgram.__isAmbassador = true;
    return __bulkGetLoyaltyProgram;
}
/**
 * Updates the loyalty program.
 *
 * You cannot activate the loyalty program using this endpoint. To do so, use the [Activate Loyalty Program endpoint](https://dev.wix.com/api/rest/wix-loyalty-program/program/activate-loyalty-program).
 */
export function updateLoyaltyProgram(payload) {
    var _a = serializer(_updateLoyaltyProgramRequest, { _focalPoint: _focalPoint, _image: _image, _loyaltyProgram: _loyaltyProgram, _pointDefinition: _pointDefinition }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLoyaltyProgramResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _loyaltyProgram: _loyaltyProgram,
        _pointDefinition: _pointDefinition,
    }).fromJSON;
    function __updateLoyaltyProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'PATCH',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.UpdateLoyaltyProgram',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLoyaltyProgram.fromReq = fromReq;
    __updateLoyaltyProgram.__isAmbassador = true;
    return __updateLoyaltyProgram;
}
/**
 * Activates a loyalty program.
 *
 * When a loyalty program is installed it starts in `DRAFT` status. Customers cannot earn or redeem points while the program is not `ACTIVE`.
 */
export function activateLoyaltyProgram(payload) {
    var _a = serializer(_activateLoyaltyProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_activateLoyaltyProgramResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _loyaltyProgram: _loyaltyProgram,
        _pointDefinition: _pointDefinition,
    }).fromJSON;
    function __activateLoyaltyProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.ActivateLoyaltyProgram',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program/activate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __activateLoyaltyProgram.fromReq = fromReq;
    __activateLoyaltyProgram.__isAmbassador = true;
    return __activateLoyaltyProgram;
}
/** Changes the program status to `PAUSED`. */
export function pauseLoyaltyProgram(payload) {
    var _a = serializer(_pauseLoyaltyProgramRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_pauseLoyaltyProgramResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _loyaltyProgram: _loyaltyProgram,
        _pointDefinition: _pointDefinition,
    }).fromJSON;
    function __pauseLoyaltyProgram(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.PauseLoyaltyProgram',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program/pause',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __pauseLoyaltyProgram.fromReq = fromReq;
    __pauseLoyaltyProgram.__isAmbassador = true;
    return __pauseLoyaltyProgram;
}
/** Retrieves the program description. */
export function getLoyaltyProgramDescription(payload) {
    var _a = serializer(_getLoyaltyProgramDescriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoyaltyProgramDescriptionResponse, {}).fromJSON;
    function __getLoyaltyProgramDescription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.GetLoyaltyProgramDescription',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program/description',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoyaltyProgramDescription.fromReq = fromReq;
    __getLoyaltyProgramDescription.__isAmbassador = true;
    return __getLoyaltyProgramDescription;
}
/** Updates the program description. */
export function updateLoyaltyProgramDescription(payload) {
    var _a = serializer(_updateLoyaltyProgramDescriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateLoyaltyProgramDescriptionResponse, {}).fromJSON;
    function __updateLoyaltyProgramDescription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'PUT',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.UpdateLoyaltyProgramDescription',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program/description',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateLoyaltyProgramDescription.fromReq = fromReq;
    __updateLoyaltyProgramDescription.__isAmbassador = true;
    return __updateLoyaltyProgramDescription;
}
/** Retrieves information about the available loyalty program premium features. */
export function getLoyaltyProgramPremiumFeatures(payload) {
    var _a = serializer(_getLoyaltyProgramPremiumFeaturesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoyaltyProgramPremiumFeaturesResponse, {}).fromJSON;
    function __getLoyaltyProgramPremiumFeatures(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.GetLoyaltyProgramPremiumFeatures',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program/premium-features',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoyaltyProgramPremiumFeatures.fromReq = fromReq;
    __getLoyaltyProgramPremiumFeatures.__isAmbassador = true;
    return __getLoyaltyProgramPremiumFeatures;
}
/** Updates the `pointsExpiration` status to `ENABLED`. */
export function enablePointsExpiration(payload) {
    var _a = serializer(_enablePointsExpirationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enablePointsExpirationResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _loyaltyProgram: _loyaltyProgram,
        _pointDefinition: _pointDefinition,
    }).fromJSON;
    function __enablePointsExpiration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.EnablePointsExpiration',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program/points-expiration/enable',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enablePointsExpiration.fromReq = fromReq;
    __enablePointsExpiration.__isAmbassador = true;
    return __enablePointsExpiration;
}
/** Updates the `pointsExpiration` status to `DISABLED`. */
export function disablePointsExpiration(payload) {
    var _a = serializer(_disablePointsExpirationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disablePointsExpirationResponse, {
        _focalPoint: _focalPoint,
        _image: _image,
        _loyaltyProgram: _loyaltyProgram,
        _pointDefinition: _pointDefinition,
    }).fromJSON;
    function __disablePointsExpiration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.program',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.program.LoyaltyPrograms.DisablePointsExpiration',
            url: resolveComWixpressLoyaltyProgramLoyaltyProgramsUrl({
                protoPath: '/v1/program/points-expiration/disable',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disablePointsExpiration.fromReq = fromReq;
    __disablePointsExpiration.__isAmbassador = true;
    return __disablePointsExpiration;
}
//# sourceMappingURL=http.impl.js.map